<template>
    <main ref="scrollComponent" class="mx-auto">
        <section v-if="getLoadingSubject">
            <Carousel v-bind="settings" :breakpoints="breakpoints">
                <slide v-for="(loading, index) in 6" :key="index">
                    <VideoSkeleton />
                </slide>
            </Carousel>
        </section>
        <section v-else>
            <Carousel v-bind="settings" :breakpoints="breakpoints">
                <slide v-for="subject in getSubjects" :key="subject.id">
                    <router-link :to="'#idSubject_' + subject.id" class="px-2 w-full">
                        <blockquote class="flex h-full flex-col justify-between bg-white p-8 border border-secondary rounded-sm text-left dark:bg-secondary/50 hover:dark:bg-secondary/80">
                            <div class="h-[5.5rem] font-bold text-secondary dark:text-white text-md sm:text-xl" style="display: -webkit-box; -webkit-line-clamp: 3; overflow: hidden;white-space: normal; -webkit-box-orient: vertical;">
                                {{ subject.nome }}
                            </div>
                            <div v-if="subject.aulas" class="flex items-center ml-2 mt-3 text-lg text-gray-600 dark:text-white">
                                <svg class="w-6 h-6 mr-2 text-secondary dark:text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M22 17a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2h-2v2h2v-2zm-7-2a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2h-2v2h2v-2zm-7-2a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2H3v2h2v-2zM22 9a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2h-2v2h2v-2zm-7-2a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2h-2v2h2v-2zM6 9a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2H3v2h2v-2zM22 1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V2a1 1 0 011-1h4zm-1 2h-2v2h2V3zm-7-2a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V2a1 1 0 011-1h4zm-1 2h-2v2h2V3zM6 1a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h4zM5 3H3v2h2V3z"></path></svg>
                                <p>Quantidade de Aulas :  {{ subject.aulas.length }}</p>
                            </div>
                        </blockquote>
                    </router-link>
                </slide>
                <template #addons>
                    <Navigation />
                </template>
            </Carousel>
        </section>
    </main>
</template>
<script>
    import VideoSkeleton from '@/components/VideoSkeletonComponent.vue';
    import { Carousel, Slide, Navigation } from 'vue3-carousel'
    import { mapGetters } from 'vuex';

    export default {
        name: 'CarouselVideosComponent',
        data: () => ({
            settings: {
                itemsToShow: 1.1,
                snapAlign: 'center',
            },
            breakpoints: {
                580: {
                    itemsToShow: 1.2,
                    snapAlign: 'start',
                },
                700: {
                    itemsToShow: 1.5,
                    snapAlign: 'start',
                },
                880: {
                    itemsToShow: 1.8,
                    snapAlign: 'start',
                },
                1000: {
                    itemsToShow: 2.2,
                    snapAlign: 'start',
                },
                1200: {
                    itemsToShow: 3.2,
                    snapAlign: 'start',
                },
                1440: {
                    itemsToShow: 4.2,
                    snapAlign: 'start',
                },
                1800: {
                    itemsToShow: 5.2,
                    snapAlign: 'start',
                }
            },
        }),
        components: {
            VideoSkeleton,
            Carousel,
            Slide,
            Navigation
        },
        computed:{
            ...mapGetters(['getLoadingSubject', 'getSubjects']),
        },
    }
</script>
<style >
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}



.carousel__prev,
.carousel__next {
  height: 100%!important;
  width: 50px!important;
  margin: 0!important;
  box-sizing: content-box;
  /* background-color: white; */
}
.carousel__next--disabled, 
.carousel__prev--disabled {
    display: none!important;
    opacity: 0!important;
}
.carousel__icon{
    color: white;
    background-color: rgba(0,0,0,.3);
  }
</style>